<footer class="bg-black text-white py-12">
    <div class="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-3 gap-8">
  
      <!-- Left Section: Logo & Tagline -->
      <div>
        <!-- <h2 class="text-2xl font-bold">Clearscrap</h2> -->
        <a routerLink="/" class="text-2xl font-bold text-gray-900">
          <img src="images/footer-logo.png" alt="Hero Scrap Image" class="" />
        </a>
        <p class="text-gray-400 text-sm mt-2">
          We make scrap collection seamless and rewarding.
        </p>
      </div>
  
      <!-- Middle Section: Mailing List & Links -->
      <div class="text-center">
        <h3 class="text-lg font-semibold mb-2">Join our mailing list</h3>
        <div class="flex flex-col sm:flex-row gap-2 justify-center">
          <input type="email" placeholder="Your email here"
            class="w-full px-4 py-2 rounded bg-gray-800 text-white text-sm placeholder-gray-400 border border-gray-700 focus:outline-none focus:ring-2 focus:ring-white" />
          <button class="bg-white text-black px-4 py-2 rounded text-sm hover:bg-gray-200">Subscribe</button>
        </div>
      </div>
  
      <!-- Right Section: App Store Links -->
      <div class="text-center md:text-right">
        <h4 class="text-sm font-semibold mb-2">Download App</h4>
        <div class="flex flex-col items-end md:justify-end gap-3">
          <a href="https://apps.apple.com/in/app/clearscrap/id6748278098" 
               class="transform hover:scale-105 transition-transform duration-200 shadow-lg hover:shadow-xl rounded-lg overflow-hidden">
              <img src="images/footer-download-app-appstore.png" 
                   alt="Download ClearScrap on Apple App Store" 
                   class="h-14 w-auto" />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.clearscrap" 
               class="transform hover:scale-105 transition-transform duration-200 shadow-lg hover:shadow-xl rounded-lg overflow-hidden">
              <img src="images/footer-download-app-playstore.png" 
                   alt="Download ClearScrap on Google Play Store" 
                   class="h-14 w-auto" />
            </a>
          </div>
      </div>
  
    </div>
  
    <!-- Bottom Section: Links & Copyright -->
    <div class="border-t border-gray-700 mt-10 pt-4 text-center text-sm text-gray-500">
      <div class="flex justify-center gap-4 mb-2">        
        <a routerLink="/privacy-policy" class="hover:text-white" routerLinkActive="active" ariaCurrentWhenActive="page">Privacy Policy</a>
        <a  routerLink="/terms-of-service" class="hover:text-white" routerLinkActive="active" ariaCurrentWhenActive="page">Terms of Service</a>
        <a href="#" class="hover:text-white">Cookie Settings</a>
      </div>
      <p>&copy; {{ currentYear }} Clearscrap. All rights reserved.</p>
    </div>    
  </footer>